import { Button, Stack, Typography, useTheme } from '@mui/material'
import { CircleCheckIcon } from '../../../icons'

export const SuccessMessage = () => {
  const theme = useTheme()
  return (
    <Stack
      spacing={1}
      px={3}
      py={4}
      width={{ md: 540, xs: '100%' }}
      sx={{
        backgroundColor: theme.palette.background.default,
        borderRadius: 2,
        color: theme.palette.primary.dark,
      }}
      alignItems="center"
    >
      <CircleCheckIcon sx={{ fontSize: '5rem', color: 'transparent' }} />
      <Stack>
        <Typography fontSize="1.25rem" fontWeight={600} color="text.primary">
          Thank you!
        </Typography>

        <Typography fontSize="1rem" color={theme.palette.grey[600]} fontWeight={500}>
          Look for your water test kit in the mail!
        </Typography>
        <Button href={'https://sippsafely.com/our-vision'} variant="contained" sx={{margin:'1rem auto 0  auto' }}>Our Vision</Button>
      </Stack>
    </Stack>
  )
}
